<div class="chart-card">
    <div class="title">{{title}}</div>
    <canvas baseChart [datasets]="lineChartData" [options]="lineChartOptions" [colors]="lineChartColors"
        [legend]="lineChartLegend" [chartType]="lineChartType" [plugins]="lineChartPlugins">
    </canvas>
</div>